export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-tracker/:pageId',
        component: () => import('@/views/page/company/procurement/budget-tracker/List.vue'),
        name: 'budget-tracker',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-tracker-add/:pageId',
        component: () => import('@/views/page/company/procurement/budget-tracker/Add.vue'),
        name: 'budget-tracker-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-tracker-edit/:pageId/:budgetId',
        component: () => import('@/views/page/company/procurement/budget-tracker/Add.vue'),
        name: 'budget-tracker-edit',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-tracker-approval/:pageId',
        component: () => import('@/views/page/company/procurement/budget-tracker/approval/List.vue'),
        name: 'budget-tracker-approval',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-tracker-review/:pageId/:budgetId/:versionId',
        component: () => import('@/views/page/company/procurement/budget-tracker/approval/Review.vue'),
        name: 'budget-tracker-review',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/budget-line-bva/:pageId',
        component: () => import('@/views/page/company/procurement/budget/report/budget-line-bva/List.vue'),
        name: 'budget-line-bva',
        meta: {
            requiresAuth: true
        }
    },
]
